module.exports = __webpack_public_path__ + "static/media/CUSIS E - EH - S.fdfecebf.png";